<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-bug-check</v-icon>{{ item['qualityCheckTest'].name }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <QualityCheckValueForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import QualityCheckValueForm from '../../components/qualitycheckvalue/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'QualityCheckValue';
const routeAfterDel = 'QualityCheckUpdate';
const routeAfterDelId = 'qualityCheck';

export default {
  name: 'QualityCheckValueUpdate',
  servicePrefix,
  routeAfterDel,
  routeAfterDelId,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    QualityCheckValueForm
  },

  computed: {
    ...mapFields('qualitycheckvalue', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('qualitycheckvalue', ['find'])

  },

  methods: {
    ...mapActions('qualitycheckvalue', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
